<template>
    <div style="padding: 5% 15%;">

        <p  class="i18n-text">
            {{ $t("aboutMe") }}
        </p>
        <div v-if="0" style="display: flex;justify-content: center;flex-wrap: wrap;">
            <a :href="badge.url0" target="_blank" v-for="badge in showBadgeList" style="margin: 0 2px;">

                <img
                    :src="'https://img.shields.io/badge/' + badge.text + '-' + badge.color + '?style=flat&logo=' + badge.badge + '&logoColor=white'">
            </a>
        </div>
    </div>
</template>

<script>
import { getBadgeList } from '../components/badge'
export default {
    data() {
        return {
            showBadgeList: null,
        }
    },
    mounted() {
        this.initBadge()
    },
    methods: {
        initBadge() {
            let k = ['html', 'css', 'less', 'javascri', 'java', 'openlaye', 'vue', 'spring', 'springboot', 'springsecurity', 'nginx', 'cloudflare', 'redis', 'kafka', 'docker', 'echarts', 'e',]
            let nullable = getBadgeList(k)
            console.log(k)
            console.log(nullable)
            this.showBadgeList = nullable
        }
    }
};
</script>


<style lang="less" scoped>
.i18n-text {
  white-space: pre-line;
  font-weight: bold;
  font-size: 32px;
}
</style>